<template>
  <v-app>
    <div id="app">
      <component :is="layout">
        <router-view/>
      </component>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  computed: {
    layout() {
      return this.$route.meta.layout || 'default-layout'
    }
  }
}
</script>
